import { Outlet } from 'react-router'

/**
 * Layout wrapper for all /nationals/* routes.
 * Simply renders the child route content.
 */
export default function NationalsLayout() {
	return <Outlet />
}
